// extracted by mini-css-extract-plugin
module.exports = {"typeahead":"TagsTypeahead_typeahead__H45ga","item":"TagsTypeahead_item__reFHp","link":"TagsTypeahead_link__wD87t"};